import { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import Card from "../Card";
import Title from "../Title";
import { ReactSortable } from "react-sortablejs";
import urlSlug from "url-slug";
import moment from "moment";
import {
  Button,
  Divider,
  Space,
  Switch,
  Upload,
  Input,
  Radio,
  Select,
  Drawer,
  Col,
  Modal,
  Row,
  DatePicker,
  notification,
  Form,
  Tag,
} from "antd";
import CardList from "../CardList";
import { ReactComponent as IconOk } from "../../../Assets/Images/Backoffice/Ok.svg";
import { ReactComponent as IconCalendar } from "../../../Assets/Images/Backoffice/Calendar.svg";
import { ReactComponent as IconClose } from "../../../Assets/Images/Backoffice/Close.svg";
import { ReactComponent as IconEdit } from "../../../Assets/Images/Backoffice/Edit.svg";
import { ReactComponent as IconHours } from "../../../Assets/Images/Backoffice/Hours.svg";
import { ReactComponent as IconUpload } from "../../../Assets/Images/Backoffice/Upload.svg";
import ReactQuill, { Quill } from "react-quill";
import "react-quill/dist/quill.snow.css";
import dayjs from "dayjs";
import { ExclamationCircleOutlined, PlusOutlined } from "@ant-design/icons";
import customParseFormat from "dayjs/plugin/customParseFormat";
dayjs.extend(customParseFormat);
import { EyeOutlined } from "@ant-design/icons";
import axios, { all } from "axios";
import ImageResize from "quill-image-resize-module-react";
Quill.register("modules/imageResize", ImageResize);

const { RangePicker } = DatePicker;
const { Dragger } = Upload;
const { TextArea } = Input;

// import { useDrag } from 'react-dnd'
// import { ItemTypes } from './Constants'

const WrapperCardList = styled.section`
  // display: flex;
  width: 100% !important;
  flex-direction: row;

  .datepicker {
    width: 200px;
    height: 45px;
    border: 1px solid rgb(128, 159, 184);
  }

  p {
    color: #c2c4d4;
    font-size: 14px;
    letter-spacing: 0px;
    line-height: 20px;
    margin-bottom: 0% !important;
    text-align: left;
  }

  .text {
    color: #809fb8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .regular-text {
    color: #000;
    text-align: left;
    font-size: 14px;
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .text-small {
    color: #809fb8;
    text-align: left;
    font-size: 12px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .css-dev-only-do-not-override-j0nf2s .text {
    margin-bottom: 0 !important;
  }

  .icon-close {
    cursor: pointer;
  }

  .action-edit {
    cursor: pointer;
    color: #494d7d;
  }

  .flex-wrap {
    flex-wrap: wrap !important;
  }
`;

const WrapperCardPublicacao = styled.section`
  display: flex;
  flex-direction: column;


  .close-btn {
    border: 1px solid #494D7D !important;
    color: #494D7D !important;
    height: 45px;
    background: transparent !important;
    padding: 0 50px;
  }

  .text-preview-desc, .text-preview-desc p {
    font-size: 14px !important;
    color: #c2c4d4;
  }

  .space-dates .ant-space-item, .space-dates .ant-row {
    width: 100% !important;
  }

  .w-100 {
    width: 100%;
  }

  .datepicker-input {
    width: 100% !important;
    height: 45px !important; 
    border: 1px solid rgb(128, 159, 184) !important;
  }

  .justify-end {
    display: flex;
    justify-content: flex-end !important;
    width: 100%;
    align-items: baseline !important;
  }

  .grid {
    display: grid;
    grid-template-columns: 1fr 3fr;
    gap: 20px;
  }

  .icon {
    width: 25px;
  }

  .size-eye svg {
    width: 25px;
  }

  .ant-upload-btn {
  min-height: 190px;
}

  .ant-radio-button-wrapper {
    height: 45px;
    border: 1px solid rgb(128, 159, 184);
  }

  .ant-radio-button-wrapper span {
    line-height: 45px; 
    font-size: 14px;s
  }
  .text {
    margin-bottom: 0% !important;
  }

  h4 {
    text-align: center;
    font: normal normal bold 20px/20px Roboto;
    letter-spacing: 0px;
    color: #050505;
  }
  

  .text {
    color: #809FB8;
    text-align: left;
    font-size: 14px;
    font-weight: bold;
    line-height: 24px;
    letter-spacing: 0px;
  }

  .center {
    text-align: center;
  }

  .ant-upload-wrapper .ant-upload-drag {
    max-height: -webkit-fill-available;
    height: 91%;
    display: flex;
    justify-content: center;
  }

  .ant-upload-wrapper .ant-upload-drag .ant-upload-btn  {
    height: -webkit-fill-available;
  }

  .div-sortable {
    display: flex;
    justify-content: flex-start;
    flex-flow: row wrap;
  }

  .div-sortable .ant-col {
    padding: 5px;
  }

  .div-publicacao{
    display: flex;
    justify-content: space-between;
    flex-direction: column;
  }

  .cta {
    display: block !important;
    font-size: 15px;
    padding: 0 30px !important;
    font-weight: bold;
    height: 45px !important;
    line-height: 18px;

    i { margin: 0 3px; }

    a { text-decoration: none; }
  }

  


  .cta.publish {
    margin-right: 0;

    svg path {
      fill: #FFF;
    }
  }
`;

const ContentHeader = styled.div`
  align-items: center;
  display: grid;
  gap: 22px;
  grid-template-columns: 1fr auto;
`;

const ContentFooter = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  button {
    display: block !important;
    font-size: 15px;
    font-weight: bold;
    height: 45px;
    line-height: 18px;

    i {
      margin: 0 3px;
    }
  }

  a {
    text-decoration: none;
  }
`;

var styles = {
  h6_label: {
    color: "#809FB8",
    fontFamily: "Roboto",
    fontSize: "15px",
    marginTop: "1%",
  },
  input_class_disabled: {
    marginBottom: "2%",
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    opacity: 0.6,
    pointerPublicacaos: "none",
  },
  input_class: {
    borderRadius: "6px",
    height: "45px",
    border: "1px solid #809FB8",
    color: "#0C1151",
    width: "100%",
  },
  select_class: {
    borderRadius: "6px",
    height: "45px",
    color: "#0C1151",
    width: "100%",
  },
  textarea_class: {
    borderRadius: "6px",
    border: "1px solid #809FB8",
    color: "#0C1151",
  },
  switch_label: {
    fontFamily: "Roboto",
    fontSize: "16px",
    fontWeight: "bold",
    height: "45px",
    borderRadius: "8px",
    padding: "0px 16px",
    color: "#809FB8",
    border: "1px solid #809FB8",
    textAlign: "center",
  },
  upload: {
    width: "100%",
  },
};

const CardHeader = styled.div`
  align-items: center;
  display: grid;
  grid-template-columns: 1fr auto auto;
`;

export default function CardPublicacoes(props) {
  const session_storage = JSON.parse(localStorage.getItem("session_data"));
  const [form] = Form.useForm();
  const [editForm] = Form.useForm();
  const [filePublicacaoList, setfilePublicacaoList] = useState([]);
  const [uploading, setUploading] = useState(false);
  const [showPubForm, setShowPubForm] = useState(false);
  const [showLinkForm, setShowLinkForm] = useState(false);
  const [isRevistasCientificas, setIsRevistasCientificas] = useState(false);
  const [isOutrasSociedades, setIsOutrasSociedades] = useState(false);
  const [isLinksUteisEdit, setIsLinksUteisEdit] = useState(false);
  const [isPublicacoesEdit, setIsPublicacoesEdit] = useState(false);
  const [isOutrasSociedadesEdit, setIsOutrasSociedadesEdit] = useState(0);
  const [isRevistasCientificasEdit, setIsRevistasCientificasEdit] = useState(0);
  const [showPublicacaoDrawer, setShowPublicacaoDrawer] = useState(false);
  // editar Publicacao
  const [filePublicacaoListEdit, setfilePublicacaoListEdit] = useState([]);
  const [publicacaoIdEdit, setpublicacaoIdEdit] = useState("");
  const [imagemDestaqueEdit, setImagemDestaqueEdit] = useState("");
  const [idToRemove, setIdToRemove] = useState(false);
  const [titleToRemove, setTitleToRemove] = useState(false);
  const [removePublicacaoModalOpen, setRemovePublicacaoModalOpen] =
    useState(false);

  const [allItems, setAllItems] = useState([]);

  const [publicacoes, setPublicacoes] = useState([]);
  const [linksUteis, setLinksUteis] = useState([]);

  const stringToDate = (dataStr) => {
    const [dia, mes, ano] = dataStr.split("/").map(Number);
    return new Date(ano, mes - 1, dia); // Meses são de 0 a 11
  };

  const handlePublicacoes = (allPublicacoes) => {
    let publicacoesToShow = [];
    allPublicacoes?.map((publicacao) => {
      if (publicacao != null) {
        let criado_em = new Date(publicacao.created_at);
        publicacao.created_at = criado_em.toLocaleDateString();
        publicacao.slug = urlSlug(publicacao.titulo);
        publicacao.slug += "-" + publicacao.id;
        publicacoesToShow.push(publicacao);
      }
    });

    setPublicacoes(
      publicacoesToShow
        .filter((a) => {
          return a.is_publicacao == 1;
        })
        .sort((a, b) => a.ordem - b.ordem)
    );
    setLinksUteis(
      publicacoesToShow
        .filter((a) => {
          return a.is_link_util == 1;
        })
        .sort((a, b) => a.ordem - b.ordem)
    );
  };

  useEffect(() => {
    fetch(`https://api.spap.pt/api/all-publicacoes`, {
      method: "GET",
    })
      .then((response) => {
        if (!response.ok) {
          throw new Error("Erro ao buscar publicacoes");
        }
        return response.json();
      })
      .then((data) => {
        handlePublicacoes(data.publicacoes);
      })
      .catch((error) => console.error(error));
  }, []);

  const [currentItemsPublicacao, setCurrentItemsPublicacao] = useState(
    allItems.slice(0, 2)
  );

  const [itemOffsetPublicacao, setItemOffsetPublicacao] = useState(0);
  const itemsPerPagePublicacao = 2;

  const handlePagePublicacao = (page) => {
    const newOffset = ((page - 1) * itemsPerPagePublicacao) % allItems.length;
    setItemOffsetPublicacao(newOffset);
  };

  useEffect(() => {
    const endOffset = itemOffsetPublicacao + itemsPerPagePublicacao;
    setCurrentItemsPublicacao(allItems.slice(itemOffsetPublicacao, endOffset));
  }, [itemOffsetPublicacao, allItems]);

  notification.config({
    placement: "bottomRight",
    bottom: 10,
    duration: 5,
    rtl: false,
  });

  const clickToPublicacaoDrawer = (item) => {
    setpublicacaoIdEdit(item.id);
    editForm.setFieldsValue({
      titulo: item.titulo,
      descricao: item.descricao,
      link_externo: item.link_externo,
      doi: item.doi,
    });
    setIsPublicacoesEdit(item.is_publicacao);
    setIsLinksUteisEdit(item.is_link_util);
    setIsOutrasSociedadesEdit(item.is_outra_sociedade);
    setIsRevistasCientificasEdit(item.is_revista_cientifica);
    setImagemDestaqueEdit(item.imagem_destaque);
    setShowPublicacaoDrawer(true);
  };

  const propPublicacao = {
    onRemove: (file) => {
      const index = filePublicacaoList.indexOf(file);
      const newfilePublicacaoList = filePublicacaoList.slice();
      newfilePublicacaoList.splice(index, 1);
      setfilePublicacaoList(newfilePublicacaoList);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });

        return isImage || Upload.LIST_IGNORE;
      }
      setfilePublicacaoList([...filePublicacaoList, file]);
      return false;
    },
    filePublicacaoList,
  };

  const t = 1;
  const data = [];

  const modules = {
    toolbar: [
      [{ header: "1" }, { header: "2" }, { font: [] }],
      [{ size: [] }],
      ["bold", "italic", "underline", "strike", "blockquote"],
      [
        { align: "" },
        { align: "center" },
        { align: "right" },
        { align: "justify" },
      ],
      [
        { list: "ordered" },
        { list: "bullet" },
        { indent: "-1" },
        { indent: "+1" },
      ],
      ["link", "image", "video"],
      ["clean"],
    ],
    clipboard: {
      // toggle to add extra line breaks when pasting HTML:
      matchVisual: false,
    },
    imageResize: {
      // parchment: Quill.import('parchment'),
      modules: ["Resize", "DisplaySize"],
    },
  };

  const formats = [
    "header",
    "bold",
    "italic",
    "underline",
    "strike",
    "blockquote",
    "list",
    "bullet",
    "indent",
    "align",
    "link",
    "image",
    "video",
  ];

  const handlePublicacao = (e) => {
    if (
      e.titulo.length == 0 ||
      (showPubForm == true && filePublicacaoList.length == 0) ||
      (showLinkForm == true && !isOutrasSociedades && !isRevistasCientificas)
    ) {
      notification.error({
        description: "Para criar uma novo, preencha todos os campos.",
      });
      return;
    }

    const formData = new FormData();
    formData.append("titulo", e.titulo);
    formData.append("file", filePublicacaoList[0]);
    formData.append("descricao", e.descricao);
    formData.append("link_externo", e.link_externo);
    formData.append("doi", e.doi);
    formData.append("is_publicacao", showPubForm == true ? 1 : 0);
    formData.append("is_link_util", showLinkForm == true ? 1 : 0);
    formData.append("is_outra_sociedade", isOutrasSociedades == true ? 1 : 0);
    formData.append(
      "is_revista_cientifica",
      isRevistasCientificas == true ? 1 : 0
    );

    fetch("https://api.spap.pt/api/admin/store-publicacao", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    })
      .then((response) => {
        response
          .json()
          .then((data) => {
            if (data.message == "already_exists") {
              notification.error({
                description: "Já existe uma publicação com o mesmo nome.",
              });
            } else {
              form.resetFields();
              setfilePublicacaoList([]);
              setShowLinkForm(false);
              setShowPubForm(false);
              setIsOutrasSociedades(false);
              setIsRevistasCientificas(false);
              handlePublicacoes(data.publicacoes);
              notification.success({
                description: "A publicação foi criada com sucesso!",
              });
            }
          })
          .catch((err) => {});
      })
      .then(() => {})
      .catch(() => {})
      .finally(() => {});
  };

  const propPublicacaoEdit = {
    onRemove: (file) => {
      filePublicacaoListEdit([]);
    },
    beforeUpload: (file) => {
      const isImage =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/svg+xml";
      if (!isImage) {
        notification.error({
          description: "Apenas é possível fazer upload de imagens.",
        });
        setfilePublicacaoListEdit((current) => []);
        return Upload.LIST_IGNORE;
      }
      setfilePublicacaoListEdit([...filePublicacaoListEdit, file]);
    },
    filePublicacaoListEdit,
  };

  const handleEditPublicacao = (e) => {
    if (e.titulo.length == 0 || e.descricao?.length == 0) {
      notification.error({
        description: "Para criar uma novo, preencha todos os campos.",
      });
      return;
    }
    const formData = new FormData();

    if (filePublicacaoListEdit.length) {
      formData.append("file", filePublicacaoListEdit[0]);
    }

    formData.append("publicacaoId", publicacaoIdEdit);
    formData.append("titulo", e.titulo);
    formData.append("descricao", e.descricao);
    formData.append("link_externo", e.link_externo);
    formData.append("doi", e.doi);
    formData.append("is_publicacao", isPublicacoesEdit ? 1 : 0);
    formData.append("is_link_util", isLinksUteisEdit ? 1 : 0);
    formData.append(
      "is_outra_sociedade",
      isOutrasSociedadesEdit == true ? 1 : 0
    );
    formData.append(
      "is_revista_cientifica",
      isRevistasCientificasEdit == true ? 1 : 0
    );

    setUploading(true);

    // You can use any AJAX library you
    fetch("https://api.spap.pt/api/admin/update-publicacao", {
      method: "POST",
      body: formData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        setShowPublicacaoDrawer(false);
        handlePublicacoes(data.publicacoes);
        setfilePublicacaoListEdit([]);
        notification.success({
          description: "A publicação foi atualizada com sucesso!",
        });
      });
    });
  };

  const handleRemovePublicacao = () => {
    axios
      .post(
        "https://api.spap.pt/api/admin/remove-publicacao",
        { idToRemove },
        {
          headers: {
            Accept: "application/json",
            Authorization: "Bearer " + session_storage.token,
          },
        }
      )
      .then((res) => {
        setIdToRemove("");
        setRemovePublicacaoModalOpen(false);
        if (res.status == 200) {
          session_storage.all_data.publicacoes = res.data.publicacoes;
          localStorage.setItem("session_data", JSON.stringify(session_storage));
          handlePublicacoes(res.data.publicacoes);
          notification.success({
            description: "A publicação foi removida com sucesso!",
          });
        }
      })
      .catch((error) => {
        // notification.error({description: 'Erro ao remover a imagem da galeria! Tente novamente.'});
      });
  };

  const openRemovePublicacaoModal = (id, titulo) => {
    setIdToRemove(id);
    setTitleToRemove(titulo);
    setRemovePublicacaoModalOpen(true);
  };

  const handleOrdem = (array, tipo) => {
    let ordempublicacoes = [];
    array.map(function (item, index) {
      ordempublicacoes.push({ ordem: index, id: item.id });
    });

    if (tipo == "publicacoes") {
      setPublicacoes(array);
    } else {
      setLinksUteis(array);
    }

    var bodyFormData = new FormData();
    bodyFormData.append("array", JSON.stringify(ordempublicacoes));

    fetch("https://api.spap.pt/api/admin/set-ordem-publicacao", {
      method: "POST",
      body: bodyFormData,
      headers: {
        Accept: "application/json",
        Authorization: "Bearer " + session_storage.token,
      },
    }).then((response) => {
      response.json().then((data) => {
        // handlePublicacoes(data.publicacoes);
      });
    });
  };

  const createNewPub = (type) => {
    setShowPubForm(false);
    setShowLinkForm(false);

    if (type == "publicacao" && showPubForm == false) {
      setShowPubForm(true);
    } else {
      setShowLinkForm(true);
    }
  };

  return (
    <WrapperCardPublicacao>
      <ContentHeader className="mb-10">
        <Title>Publicações e Links úteis</Title>
        <Col align="right" span={24}>
          <Space size={10}>
            <Button
              onClick={() => createNewPub("publicacao")}
              style={{
                background: "#494D7D",
                color: "#fff",
                borderRadius: "6px",
                height: "45px",
                display: "flex",
                fontWeight: "bold",
                alignItems: "center",
                padding: "0 30px",
              }}
            >
              <PlusOutlined /> Nova Publicação
            </Button>
            <Button
              onClick={() => createNewPub("link_util")}
              style={{
                background: "#494D7D",
                color: "#fff",
                borderRadius: "6px",
                height: "45px",
                display: "flex",
                fontWeight: "bold",
                alignItems: "center",
                padding: "0 30px",
              }}
            >
              <PlusOutlined /> Novo Link Útil
            </Button>
          </Space>
        </Col>
      </ContentHeader>
      {showPubForm == true && (
        <Card>
          <Form
            form={form}
            onFinish={handlePublicacao}
            className="edit-post-form"
          >
            <CardHeader>
              <Row align={"middle"}>
                <Col span={9}>
                  <Title>Publicações</Title>

                  <p className="text">
                    Disponíveis para consultar na página Publicações
                  </p>
                </Col>
              </Row>
            </CardHeader>
            <Divider style={{ margin: "12px 0" }} />
            <Row gutter={[12, 18]} align="bottom" justify={"space-between"}>
              <Col span={24}>
                <label className="text">Título</label>
                <Form.Item
                  name="titulo"
                  rules={[
                    { required: true, message: "O título é obrigatório" },
                  ]}
                  style={{ width: "100%" }}
                >
                  <Input placeholder="Título" style={styles.input_class} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[12, 18]} align={"top"}>
              <Col span={6}>
                <p
                  className="text"
                  style={{ marginBottom: "0px" }}
                  align="center"
                >
                  Tamanho máximo de upload (1 MB)
                </p>
                <Dragger
                  {...propPublicacao}
                  style={{ height: "100%" }}
                  fileList={[...filePublicacaoList]}
                >
                  <p className="ant-upload-drag-icon">
                    <IconUpload />
                  </p>
                  <p className="ant-upload-text text">Upload da imagem</p>
                  <p className="ant-upload-hint">Faça Drag and drop aqui</p>
                </Dragger>
              </Col>
              <Col span={18}>
                <label className="text" style={{ marginBottom: "0px" }}>
                  Descrição
                </label>
                <Form.Item name="descricao" style={{ width: "100%" }}>
                  <Input.TextArea
                    placeholder="Descrição"
                    className="textarea-input"
                    rows={8}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[12, 18]}>
              <Col span={16}>
                <label className="text">Link externo</label>
                <Form.Item name="link_externo" style={{ width: "100%" }}>
                  <Input
                    placeholder="Link externo (https://...)"
                    style={styles.input_class}
                  />
                </Form.Item>
              </Col>
              <Col span={8}>
                <label className="text">DOI</label>
                <Form.Item name="doi" style={{ width: "100%" }}>
                  <Input placeholder="DOI" style={styles.input_class} />
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row justify={"end"}>
              <Space size={10}>
                <Button
                  onClick={() => setShowPubForm(false)}
                  className="close-btn hide-event"
                >
                  Fechar
                </Button>
                <Button
                  type="primary"
                  className="cta publish"
                  htmlType="submit"
                  align="end"
                >
                  Publicar <IconOk className="icon icon-ok" />
                </Button>
              </Space>
            </Row>
          </Form>
        </Card>
      )}
      {showLinkForm == true && (
        <Card>
          <Form
            form={form}
            onFinish={handlePublicacao}
            className="edit-post-form"
          >
            <CardHeader>
              <Row align={"middle"}>
                <Col span={9}>
                  <Title>Links Úteis</Title>

                  <p className="text">
                    Disponíveis para consultar na página Publicações
                  </p>
                </Col>
                <Col span={15} align="right">
                  <Space size={20} className="justify-end" align={"middle"}>
                    <Space>
                      <span className="regular-text">Outras Sociedades</span>
                      {isOutrasSociedades == 1 || isOutrasSociedades == true ? (
                        <>
                          {" "}
                          <Switch
                            checked
                            onChange={(e) => setIsOutrasSociedades(e)}
                          />
                        </>
                      ) : (
                        <>
                          <Switch onChange={(e) => setIsOutrasSociedades(e)} />
                        </>
                      )}
                    </Space>
                    <Space>
                      <span className="regular-text">
                        Revistas Cientifícas e Afins
                      </span>
                      {isRevistasCientificas == 1 ||
                      isRevistasCientificas == true ? (
                        <>
                          {" "}
                          <Switch
                            checked
                            onChange={(e) => setIsRevistasCientificas(e)}
                          />
                        </>
                      ) : (
                        <>
                          <Switch
                            onChange={(e) => setIsRevistasCientificas(e)}
                          />
                        </>
                      )}
                    </Space>
                  </Space>
                </Col>
              </Row>
            </CardHeader>
            <Divider style={{ margin: "12px 0" }} />
            <Row gutter={[12, 18]} align="bottom" justify={"space-between"}>
              <Col span={24}>
                <label className="text">Título</label>
                <Form.Item
                  name="titulo"
                  rules={[
                    { required: true, message: "O título é obrigatório" },
                  ]}
                  style={{ width: "100%" }}
                >
                  <Input placeholder="Título" style={styles.input_class} />
                </Form.Item>
              </Col>
            </Row>
            <Row gutter={[12, 18]}>
              <Col span={24}>
                <label className="text">Link externo</label>
                <Form.Item name="link_externo" style={{ width: "100%" }}>
                  <Input
                    placeholder="Link externo (https://...)"
                    style={styles.input_class}
                  />
                </Form.Item>
              </Col>
            </Row>
            <Divider style={{ margin: "12px 0" }} />
            <Row justify={"end"}>
              <Space size={10}>
                <Button
                  onClick={() => setShowLinkForm(false)}
                  className="close-btn hide-event"
                >
                  Fechar
                </Button>
                <Button
                  type="primary"
                  className="cta publish"
                  htmlType="submit"
                  align="end"
                >
                  Publicar <IconOk className="icon icon-ok" />
                </Button>
              </Space>
            </Row>
          </Form>
        </Card>
      )}
      <WrapperCardList>
        <Divider>Publicações</Divider>
        {publicacoes?.length == 0 && (
          <p style={{ textAlign: "center" }}>
            Não existem publicações disponíveis.
          </p>
        )}
        {publicacoes?.length > 0 && (
          <>
            <ReactSortable
              list={publicacoes}
              setList={(e) => handleOrdem(e, "publicacoes")}
              className="div-sortable"
            >
              {publicacoes.map((item, index) => {
                let textPreview = item?.descricao
                  ?.replace(/<[^>]*>/g, "") // Remove todas as tags HTML
                  .slice(0, 140);
                if (item.descricao.length > 140) textPreview += " (...)";
                return (
                  <Col span={12}>
                    <Card
                      key={"publicacoes-" + item.id}
                      className="div-publicacao"
                      style={{ height: "100%" }}
                    >
                      <div>
                        <CardHeader>
                          <Title>{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemovePublicacaoModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                        <div
                          className="text-preview-desc"
                          dangerouslySetInnerHTML={{ __html: textPreview }}
                        ></div>
                      </div>
                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignContent: "center",
                          }}
                        >
                          <Space size={5}>
                            <Space
                              size={0}
                              className="action-edit"
                              key={"Publicacao-" + index}
                              onClick={() => clickToPublicacaoDrawer(item)}
                            >
                              <IconEdit className="icon icon-edit" />
                              <span>Editar</span>
                            </Space>
                          </Space>
                          <div>
                            <Space size={5} className="mr-10">
                              <Space size={0}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text-small">
                                  Criado em {item.created_at}
                                </span>
                              </Space>
                            </Space>
                            <Space className="action-edit">
                              <a
                                target="_blank"
                                href={
                                  "https://spap.pt/spap/publicacoes/" +
                                  item.slug
                                }
                              >
                                <EyeOutlined
                                  className="size-eye"
                                  style={{ paddingRight: "5px", width: "30px" }}
                                />
                              </a>
                            </Space>
                          </div>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </ReactSortable>
          </>
        )}

        <Divider>Links Úteis</Divider>
        {linksUteis?.length == 0 && (
          <p style={{ textAlign: "center" }}>
            Não existem links úteis disponíveis.
          </p>
        )}
        {linksUteis?.length > 0 && (
          <>
            <ReactSortable
              list={linksUteis}
              setList={(e) => handleOrdem(e, "linksUteis")}
              className="div-sortable"
            >
              {linksUteis.map((item, index) => {
                let textPreview = item?.descricao
                  ?.replace(/<(h2|h3|img|b|strong)[^>]*>/g, "<p>")
                  .slice(0, 100);
                if (item.descricao.length > 120) textPreview += " (...)";
                return (
                  <Col span={12}>
                    <Card
                      key={"publicacoes-" + item.id}
                      className="div-publicacao"
                      style={{ height: "100%" }}
                    >
                      <div>
                        <CardHeader>
                          <Title>{item.titulo}</Title>
                          <IconClose
                            className="icon icon-close"
                            onClick={() =>
                              openRemovePublicacaoModal(item.id, item.titulo)
                            }
                          />
                        </CardHeader>
                        {item.is_outra_sociedade == 1 && (
                          <Tag color="green">Outras sociedades</Tag>
                        )}
                        {item.is_revista_cientifica == 1 && (
                          <Tag color="blue">Revistas Ciêntificas</Tag>
                        )}
                      </div>

                      <Space direction="vertical" style={{ width: "100%" }}>
                        <Space
                          style={{
                            display: "flex",
                            justifyContent: "space-between",
                            width: "100%",
                            alignContent: "center",
                          }}
                        >
                          <Space size={5}>
                            <Space
                              size={0}
                              className="action-edit"
                              key={"Publicacao-" + index}
                              onClick={() => clickToPublicacaoDrawer(item)}
                            >
                              <IconEdit className="icon icon-edit" />
                              <span>Editar</span>
                            </Space>
                          </Space>
                          <div>
                            <Space size={5} className="mr-10">
                              <Space size={0}>
                                <IconCalendar className="icon icon-calendar" />
                                <span className="text-small">
                                  Criado em {item.created_at}
                                </span>
                              </Space>
                            </Space>
                            <Space className="action-edit">
                              <a
                                target="_blank"
                                href={
                                  "https://spap.pt/spap/publicacoes/" +
                                  item.slug
                                }
                              >
                                <EyeOutlined
                                  className="size-eye"
                                  style={{ paddingRight: "5px", width: "30px" }}
                                />
                              </a>
                            </Space>
                          </div>
                        </Space>
                      </Space>
                    </Card>
                  </Col>
                );
              })}
            </ReactSortable>
          </>
        )}

        <Drawer
          key={"editar-publicacao-" + publicacaoIdEdit}
          title="Editar Publicação"
          width={isLinksUteisEdit == 1 ? 600 : 1200}
          onClose={() => setShowPublicacaoDrawer(false)}
          open={showPublicacaoDrawer}
          bodyStyle={{
            paddingTop: 15,
          }}
          extra={
            <Space>
              <Button onClick={() => setShowPublicacaoDrawer(false)}>
                Cancelar
              </Button>
              <Button
                onClick={() => editForm.submit()}
                type="submit"
                style={{
                  borderRadius: "6px",
                  background: "#494D7D",
                  color: "#fff",
                }}
              >
                Guardar
              </Button>
            </Space>
          }
        >
          <Form
            form={editForm}
            onFinish={handleEditPublicacao}
            className="edit-post-form"
          >
            {isLinksUteisEdit == 1 && (
              <>
                <Row justify={"space-between"} align={"middle"}>
                  <Col className="d-flex gap-20">
                    <div className="d-flex gap-10">
                      <span className="regular-text">Outras Sociedades</span>
                      {isOutrasSociedadesEdit == 1 ||
                      isOutrasSociedadesEdit == true ? (
                        <>
                          {" "}
                          <Switch
                            checked
                            onChange={(e) => setIsOutrasSociedadesEdit(e)}
                          />
                        </>
                      ) : (
                        <>
                          <Switch
                            onChange={(e) => setIsOutrasSociedadesEdit(e)}
                          />
                        </>
                      )}
                    </div>
                    <div className="d-flex gap-10">
                      <span className="regular-text">
                        Revistas Cientifícas e Afins
                      </span>
                      {isRevistasCientificasEdit == 1 ||
                      isRevistasCientificasEdit == true ? (
                        <>
                          {" "}
                          <Switch
                            checked
                            onChange={(e) => setIsRevistasCientificasEdit(e)}
                          />
                        </>
                      ) : (
                        <>
                          <Switch
                            onChange={(e) => setIsRevistasCientificasEdit(e)}
                          />
                        </>
                      )}
                    </div>
                  </Col>
                </Row>
                <Divider
                  style={{ background: "#fff", margin: "12px 0" }}
                ></Divider>
              </>
            )}
            <Col>
              {isPublicacoesEdit == 1 && (
                <Row align={"middle"}>
                  <Col span={12}>
                    <h5 style={{ marginBottom: "10px", fontSize: "18px" }}>
                      Upload da imagem
                    </h5>
                    <p>
                      Poderá fazer o upload de uma nova imagem de destaque
                      clicando na imagem do lado direito.
                    </p>
                  </Col>
                  <Col span={12}>
                    <Dragger
                      {...propPublicacaoEdit}
                      fileList={[...filePublicacaoListEdit]}
                      style={{
                        marginBottom: "5px",
                        width: "100%",
                        backgroundImage:
                          "url(https://api.spap.pt/publicacoes/" +
                          publicacaoIdEdit +
                          "/" +
                          imagemDestaqueEdit +
                          ")",
                        backgroundSize: "cover",
                      }}
                    >
                      <div style={{ opacity: 0 }}>
                        <p className="ant-upload-drag-icon">
                          <IconUpload />
                        </p>
                        <p className="ant-upload-text text">
                          Upload da imagem{" "}
                        </p>
                        <p className="ant-upload-hint">
                          Faça Drag and drop aqui
                        </p>
                      </div>
                    </Dragger>
                  </Col>
                </Row>
              )}
              <Divider
                style={{ background: "#fff", margin: "12px 0" }}
              ></Divider>

              <Row justify={"space-between"} align={"bottom"} gutter={[8, 8]}>
                <Col span={24}>
                  <h6 style={styles.h6_label}>Título</h6>
                  <Form.Item name="titulo" style={{ width: "100%" }}>
                    <Input
                      key={"titulo-publicacao-" + publicacaoIdEdit}
                      placeholder="Título"
                      style={styles.input_class}
                      required
                    />
                  </Form.Item>
                </Col>
                <Col span={24}>
                  <h6 style={styles.h6_label}>Link externo</h6>
                  <Form.Item name="link_externo" style={{ width: "100%" }}>
                    <Input
                      placeholder="Link externo (https://...)"
                      style={styles.input_class}
                    />
                  </Form.Item>
                </Col>
                {isPublicacoesEdit == 1 && (
                  <>
                    <Col span={8}>
                      <h6 style={styles.h6_label}>DOI</h6>
                      <Form.Item name="doi" style={{ width: "100%" }}>
                        <Input placeholder="DOI" style={styles.input_class} />
                      </Form.Item>
                    </Col>
                    <Col span={24}>
                      <h6 style={styles.h6_label}>Descrição</h6>
                      <Form.Item name="descricao" style={{ width: "100%" }}>
                        <Input.TextArea
                          placeholder="Descrição"
                          className="textarea-input"
                          rows={8}
                        />
                      </Form.Item>
                    </Col>
                  </>
                )}
              </Row>
            </Col>
          </Form>
        </Drawer>

        <Modal
          key={"remove-publicacao-" + idToRemove}
          title="Está prestes a eliminar um Publicacao"
          open={removePublicacaoModalOpen}
          onOk={handleRemovePublicacao}
          onCancel={() => setRemovePublicacaoModalOpen(false)}
          okText="Confirmar"
          cancelText="Cancelar"
        >
          <p>
            Tem a certeza que pretende remover o Publicacao{" "}
            <b>'{titleToRemove}'</b>?
          </p>
        </Modal>
      </WrapperCardList>
    </WrapperCardPublicacao>
  );
}
